export default function Certifications() {
  const certifications = [
    {
      icon: 'ri-shield-check-line',
      title: 'Licensed Electrician',
      description: 'Fully licensed and certified to Australian electrical standards'
    },
    {
      icon: 'ri-file-shield-2-line',
      title: 'Insured & Bonded',
      description: 'Comprehensive liability insurance for your protection'
    },
    {
      icon: 'ri-award-line',
      title: 'Industry Certified',
      description: 'Certified by leading electrical industry bodies'
    },
    {
      icon: 'ri-user-star-line',
      title: 'Master Electrician',
      description: 'Master electrician qualification with advanced training'
    }
  ];

  return (
    <section className="py-14 md:py-24 bg-gradient-to-br from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-10 md:mb-16">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-black text-[#535669] mb-3 md:mb-4">
            Certifications & <span className="text-[#f67f19]">Credentials</span>
          </h2>
          <p className="text-base md:text-lg text-gray-600 max-w-2xl mx-auto">
            Fully qualified and certified to deliver safe, compliant electrical work
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8">
          {certifications.map((cert, index) => (
            <div 
              key={index}
              className="bg-white rounded-xl p-6 md:p-8 shadow-lg text-center hover:shadow-xl transition-all hover:-translate-y-1"
            >
              <div className="w-16 h-16 md:w-20 md:h-20 bg-[#f67f19]/10 rounded-full flex items-center justify-center mx-auto mb-4 md:mb-6">
                <i className={`${cert.icon} text-[#f67f19] text-3xl md:text-4xl`}></i>
              </div>
              <h3 className="text-base md:text-lg font-bold text-[#535669] mb-2 md:mb-3">
                {cert.title}
              </h3>
              <p className="text-xs md:text-sm text-gray-600 leading-relaxed">
                {cert.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}